import { render, staticRenderFns } from "./MovePaymentPopup.vue?vue&type=template&id=7a965a27"
import script from "./MovePaymentPopup.vue?vue&type=script&lang=ts"
export * from "./MovePaymentPopup.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports